export const ALLOWED_IMAGE_TYPES: Record<string, string> = {
    '.jpg': 'image/jpeg',
    '.jpeg': 'image/jpeg',
    '.png': 'image/png',
    '.gif': 'image/gif',
    '.webp': 'image/webp',
    '.bmp': 'image/bmp',
};

export function getImageAcceptAttribute(): string {
    return [
        ...Object.values(ALLOWED_IMAGE_TYPES),
        ...Object.keys(ALLOWED_IMAGE_TYPES),
    ].join(',');
}
